import { render, staticRenderFns } from "./productSelect.vue?vue&type=template&id=52c27b8c&scoped=true"
import script from "./productSelect.vue?vue&type=script&lang=js"
export * from "./productSelect.vue?vue&type=script&lang=js"
import style0 from "./productSelect.vue?vue&type=style&index=0&id=52c27b8c&prod&lang=scss&scoped=true"
import style1 from "./productSelect.vue?vue&type=style&index=1&id=52c27b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c27b8c",
  null
  
)

export default component.exports